<template>
  <div>
     <v-row class="mx-2 mx-sm-10 mt-5">
        <v-col>
          <ValidationObserver
            ref="observer"
            class="box ma-auto mb-5 px-6 px-sm-12 py-3 d-flex flex-column justify-space-between  align-center rounded"
            v-slot="{ handleSubmit }"
          >
            <text-field
              v-model="currentPassword"
              :rules="{
                required: true,
                min: 4,
              }"
              class="input"
              name="currentPassword"
              type="password"
              :placeholder="$t('settings.changePassword.currentPassword')"
            >
              <template #prepend-inner>
                <iconLock class="mt-1 mr-1"></iconLock>
              </template>
            </text-field>
            <text-field
              v-model="newPassword"
              :rules="{
                required: true,
                min: 4,
              }"
              class="input"
              name="password"
              type="password"
              :placeholder="$t('settings.changePassword.newPassword')"
            >
              <template #prepend-inner>
                <iconLock class="mt-1 mr-1"></iconLock>
              </template>
            </text-field>

            <v-btn class="primary btn-text px-10 mt-4 mb-4" dark @click="handleSubmit(save)">{{ $t('settings.changePassword.saveChanges') }}</v-btn>
          </ValidationObserver>
        </v-col>
      </v-row>
  </div>
</template>

<script>
import { ValidationObserver } from 'vee-validate';
import textField from '@/components/base/textField';
import iconLock from '@/static/img/lock.svg';
import toastr from '@/plugins/toastr';

export default {
  name: 'profile',

  components: {
    iconLock,
    ValidationObserver,
    textField,
  },

  data () {
    return {
      currentPassword: '',
      newPassword: '',
    };
  },

  methods: {
    async save () {
      try {
        await this.$store.dispatch('user/UPDATE_PASSWORD', {
          currentPassword: this.currentPassword,
          newPassword: this.newPassword,
        });

        this.currentPassword = '';
        this.newPassword = '';
        this.$refs.observer.reset();
        toastr.success(this.$t('base.success'));
      } catch (error) {
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.box {
  border: 1px solid #E5E5E5;
  max-width: 330px
}

.input {
  width: 100%;
}

.btn-text {
  width: 100%;
}

  @media #{map-get($display-breakpoints, 'xs-only')} {

  }
</style>
